// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"FAQ_faqContainer__1ixBn","mainTitle":"FAQ_mainTitle__3K6Kh"};